var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRotoram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 61,
    viewBox: "0 0 49 61",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4403 24.8252L5.50879 12.179V47.3399L29.3429 60.0833L29.4403 24.8252Z",
    fill: "#C6C6C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M6.35059 31.2007L8.7737 32.5171V27.2293L6.35059 25.9204V31.2007Z",
    fill: "#575756"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.833008 13.4327L24.3426 0.916748L48.1663 13.5365L24.7175 26.0201L0.833008 13.4327Z",
    fill: "#D9D9D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9855 59.3577L27.678 59.1932L27.6781 29.0212L9.34759 19.407L9.34775 49.3926L9.04042 49.2283L9.04004 18.9187L27.9856 28.8553L27.9855 59.3577Z",
    fill: "#575756"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0342 23.1104V52.9683L20.9728 55.6196V27.1667L16.0342 23.1104ZM20.3937 53.1983L16.6133 51.177V39.4341L20.3937 41.4551V53.1983ZM20.3937 37.262L16.6133 35.2409V25.4491L20.3937 27.443V37.262Z",
    fill: "#575756"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M20.9728 55.6197L16.0342 52.9684V23.97L20.9728 26.6063V55.6197Z",
    fill: "#575756"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7175 29.2722V26.02L0.833008 13.4326V16.6848L24.7175 29.2722Z",
    fill: "#C6C6C5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9463 31.6973V37.9314C10.9463 37.9768 11.064 38.0135 11.2091 38.0135C11.3542 38.0135 11.4718 37.9768 11.4718 37.9314V31.6973H10.9463Z",
    fill: "#9C9B9B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2091 31.7793C11.3542 31.7793 11.4718 31.7425 11.4718 31.6972C11.4718 31.652 11.3542 31.6152 11.2091 31.6152C11.0639 31.6152 10.9463 31.652 10.9463 31.6972C10.9463 31.7425 11.0639 31.7793 11.2091 31.7793Z",
    fill: "#D9D9D9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5015 35.4942L10.9463 35.5069L10.9851 36.9578L11.5403 36.9451C11.847 36.9381 12.0869 36.6076 12.0762 36.207C12.0655 35.8063 11.8082 35.4872 11.5015 35.4942Z",
    fill: "#6F6F6E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9856 36.9579C11.2923 36.9509 11.5322 36.6204 11.5215 36.2198C11.5108 35.8191 11.2535 35.5 10.9468 35.5071C10.6402 35.5141 10.4003 35.8446 10.411 36.2452C10.4217 36.6458 10.679 36.9649 10.9856 36.9579Z",
    fill: "#B1B1B1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2091 35.5285C11.3542 35.5285 11.4718 35.5159 11.4718 35.5005C11.4718 35.485 11.3542 35.4724 11.2091 35.4724C11.0639 35.4724 10.9463 35.485 10.9463 35.5005C10.9463 35.5159 11.0639 35.5285 11.2091 35.5285Z",
    fill: "#9C9B9B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7207 29.3304V26.0633L48.1668 13.5366V50.0268L29.3433 60.0835L29.3644 28.4111L25.605 30.4196L24.7207 29.3304Z",
    fill: "#6F6F6E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1.68724 17.7025L25.6018 30.3614L24.7175 29.2722L0.833008 16.6848L1.68724 17.7025Z",
    fill: "#B1B1B1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotoram);
export default __webpack_public_path__ + "static/media/rotoram.0e13f9201b72d192f83ba1eea4442a0a.svg";
export { ForwardRef as ReactComponent };